import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  withArrow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  withArrow = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed rounded-lg';
  const variants = {
    primary: 'bg-slate-900 text-white hover:bg-slate-800 focus:ring-slate-900 shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    secondary: 'bg-emerald-600 text-white hover:bg-emerald-700 focus:ring-emerald-600 shadow-md hover:shadow-lg hover:-translate-y-0.5',
    outline: 'border-2 border-slate-200 text-slate-900 hover:border-slate-900 hover:bg-slate-50 focus:ring-slate-900',
    ghost: 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-158" data-mp="tngbqga6hvib">
      {children}
      {withArrow && <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-159" data-mp="on11vyp3v653" />}
    </button>;
}